import React, { useState } from 'react';
import api from '../../services/api';
import '../../utils/axiosInterceptor';
import './styles.css';

export default function UploadPayments() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  function handleFileChange(e) {
    setFile(e.target.files[0]);
    setResult(null);
    setError(null);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!file) {
      setError('Selecione um arquivo antes de enviar.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const response = await api.post('/users/payment', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setResult(response.data);
    } catch (err) {
      setError(
        err.response && err.response.data && err.response.data.error
          ? err.response.data.error
          : 'Erro ao enviar a planilha.'
      );
    } finally {
      setLoading(false);
    }
  }

  async function handleRunDefaultCheck() {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const response = await api.post('/users/runDefaultCheck');
      setResult(response.data);
    } catch (err) {
      setError(
        err.response && err.response.data && err.response.data.error
          ? err.response.data.error
          : 'Erro ao executar verificação.'
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="uploadPayments">
      <div className="pageTitle">
        <span>Atualizar Pagamentos</span>
      </div>
      <div className="uploadFields">
        <form onSubmit={handleSubmit}>
          <label>Planilha de pagamentos (.xlsx, .xls, .csv)</label>
          <input
            type="file"
            accept=".xlsx,.xls,.csv"
            onChange={handleFileChange}
          />
          <input
            type="submit"
            value={loading ? 'Enviando...' : 'Enviar Planilha'}
            disabled={loading}
          />
        </form>

        <button
          className="defaultCheckButton"
          onClick={handleRunDefaultCheck}
          disabled={loading}
        >
          {loading ? 'Executando...' : 'Forçar Verificação de Inadimplência'}
        </button>

        {error && (
          <div className="uploadError">
            <span>{error}</span>
          </div>
        )}

        {result && (
          <div className="uploadResult">
            <span>{result.message}</span>
            <br />
            {result.updated !== undefined && (
              <span>Alunos atualizados: {result.updated}</span>
            )}
            {result.defaultersUpdated !== undefined && (
              <span>
                Inadimplentes: {result.defaultersUpdated} | Adimplentes: {result.solventUpdated}
              </span>
            )}
            {result.notFound && result.notFound.length > 0 && (
              <div>
                <span>CPFs não encontrados:</span>
                <ul>
                  {result.notFound.map((cpf) => (
                    <li key={cpf}>{cpf}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}